import styled from "styled-components";

export const AlertWrapper = styled.div`
  position: absolute;
  width: 100vw; 
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const AlertBackdrop = styled.div`
  background: rgba(129,129,129,0.6);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
`;

export const AlertContentWrapper = styled.div`
  width: 500px;
  height: 230px;
  padding: 0;
  overflow-y: auto;
  border-radius: 3px;
  background-color: white;
  box-shadow: 0 8px 11px 0 rgb(0 0 0 / 34%);

  z-index: 10000;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate3d(-50%, 0, 0);

  display: flex;
  flex-direction: column;
`;

export const AlertTitle = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eaeaea;

  font-size: 15px;
  font-weight: 500;

  display: flex;
  align-items: center;
`

export const AlertMessage = styled.div`
  padding: 40px 20px;
  color: #363636;
  background: #f6fafe;
  border-bottom: 1px solid #eaeaea;

  font-size: 14px;
  font-weight: 400;

  display: flex;
  align-items: center;
`

export const AlertFooter = styled.div`
  padding: 12px 20px;

  display: flex;
  justify-content: flex-end;
  gap: 15px;

  * {
    font-size: 14px;
  }
`